<template>
    <div :style="backUrl ? { backgroundImage: `url(${backUrl})` , backgroundSize: 'cover', backgroundRepeat: 'no-repeat' } : {}" class="three-column-rich-text">
        <!-- 顶部标题展示 -->
        <div class="top-margin"></div>
        <div v-if="title" class="component-title">
            {{ title }}
        </div>

        <!-- 三栏富文本内容区域 -->
        <div style="margin-top: 70px" class="columns-container">
            <div
                    v-for="(column, index) in columns"
                    :key="index"
                    class="column-item"
                    v-html="column"
            ></div>
        </div>
        <div class="top-margin"></div>
    </div>
</template>

<script>
export default {
    name: 'ThreeColumnRichText',
    props: {
        // 三栏富文本数据，格式为：富文本1@FUWENBEN@富文本2@FUWENBEN@富文本3
        sourceData: {
            type: String,
            required: true,
            default: ''
        },
        // 组件顶部标题
        title: {
            type: String,
            default: ''
        },
        backUrl:{
            type: String,
            default: ''
        },
        detailUrl:{
            type: String,
            default: ''
        },
    },
    data() {
        return {
            columns: [] // 解析后的三栏富文本内容数组
        }
    },
    watch: {
        sourceData: {
            immediate: true,
            handler(newSource) {
                this.parseSourceData(newSource)
            }
        },
        title: {
            immediate: true,
            handler() {
                // 标题变化时模板自动更新，无需额外操作
            }
        }
    },
    methods: {
        parseSourceData(source) {
            try {
                // 分割三栏富文本内容
                const parts = source.split('@FUWENBEN@')
                // 确保有三部分内容，不足则补空
                this.columns = [
                    parts[0] || '<p>无内容</p>',
                    parts[1] || '<p>无内容</p>',
                    parts[2] || '<p>无内容</p>'
                ]
            } catch (error) {
                console.error('三横图富文本解析失败:', error)
                // 解析错误时显示默认内容
                this.columns = [
                    '<p>解析错误</p>',
                    '<p>解析错误</p>',
                    '<p>解析错误</p>'
                ]
            }
        }
    }
}
</script>

<style scoped>
.three-column-rich-text {
    width: 100%;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    overflow: hidden;
    background-color: #fff;
}

/* 顶部标题样式 */
.component-title {
    padding: 16px 20px;
    background-color: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    box-sizing: border-box;
}

/* 三栏容器样式 */
.columns-container {
    display: flex;
    flex-wrap: wrap;
}

/* 每栏样式 */
.column-item {
    flex: 1;
    min-width: 300px;
    padding: 20px;
    box-sizing: border-box;
    border-right: 1px solid #e8e8e8;
    line-height: 1.6;
    color: #333;
}

.column-item:last-child {
    border-right: none;
}

/* 富文本内容中的图片样式 */
.column-item img {
    max-width: 100%;
    height: auto;
    margin: 10px 0;
}

/* 响应式适配 */
@media (max-width: 992px) {
    .columns-container {
        flex-direction: column;
    }
    .column-item {
        min-width: 100%;
        border-right: none;
        border-bottom: 1px solid #e8e8e8;
    }
    .column-item:last-child {
        border-bottom: none;
    }
}
</style>